import { FC, useMemo } from 'react';
import { useLocalizedFormat } from '../../lib';
import { DateStyled } from './date.styled';
import { IDateProps } from './date.types';

const DefaultPattern = 'd MMMM yyyy HH:mm';

export const Date: FC<IDateProps> = ({ date, pattern = DefaultPattern }) => {
  const { format } = useLocalizedFormat();

  const formattedDate = useMemo(
    () => format(date, pattern),
    [date, format, pattern],
  );

  return <DateStyled>{formattedDate}</DateStyled>;
};
